/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Lifecycle of the title this Drop promotes. Drives what a community
 * challenge is allowed to count — ANNOUNCED titles have no telemetry
 * at all, so play-verified objectives are impossible until BETA.
 * 
 * @export
 */
export const ReleaseStatus = {
    ANNOUNCED: 'ANNOUNCED',
    BETA: 'BETA',
    RELEASED: 'RELEASED'
} as const;
export type ReleaseStatus = typeof ReleaseStatus[keyof typeof ReleaseStatus];


export function instanceOfReleaseStatus(value: any): boolean {
    for (const key in ReleaseStatus) {
        if (Object.prototype.hasOwnProperty.call(ReleaseStatus, key)) {
            if (ReleaseStatus[key as keyof typeof ReleaseStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReleaseStatusFromJSON(json: any): ReleaseStatus {
    return ReleaseStatusFromJSONTyped(json, false);
}

export function ReleaseStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReleaseStatus {
    return json as ReleaseStatus;
}

export function ReleaseStatusToJSON(value?: ReleaseStatus | null): any {
    return value as any;
}

export function ReleaseStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ReleaseStatus {
    return value as ReleaseStatus;
}

